var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrettierIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file_type_prettier") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    d: "M21.714,8.571h1.143a.571.571,0,0,1,.571.571h0a.571.571,0,0,1-.571.571H21.714a.571.571,0,0,1-.571-.571h0A.571.571,0,0,1,21.714,8.571Z",
    style: {
      fill: "#56b3b4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-2",
    "data-name": "Rectangle",
    d: "M4.571,26.857h5.714a.571.571,0,0,1,.571.571h0a.571.571,0,0,1-.571.571H4.571A.571.571,0,0,1,4,27.429H4A.571.571,0,0,1,4.571,26.857Z",
    style: {
      fill: "#ea5e5e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-3",
    "data-name": "Rectangle",
    d: "M18.286,17.714h3.429a.571.571,0,0,1,.571.571h0a.571.571,0,0,1-.571.571H18.286a.571.571,0,0,1-.571-.571h0A.571.571,0,0,1,18.286,17.714Z",
    style: {
      fill: "#bf85bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-4",
    "data-name": "Rectangle",
    d: "M11.429,17.714H16a.571.571,0,0,1,.571.571h0a.571.571,0,0,1-.571.571H11.429a.571.571,0,0,1-.571-.571h0A.571.571,0,0,1,11.429,17.714Z",
    style: {
      fill: "#ea5e5e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-5",
    "data-name": "Rectangle",
    d: "M4.571,17.714H9.143a.571.571,0,0,1,.571.571h0a.571.571,0,0,1-.571.571H4.571A.571.571,0,0,1,4,18.286H4A.571.571,0,0,1,4.571,17.714Z",
    style: {
      fill: "#56b3b4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-6",
    "data-name": "Rectangle",
    d: "M4.571,22.286h5.714a.571.571,0,0,1,.571.571h0a.571.571,0,0,1-.571.571H4.571A.571.571,0,0,1,4,22.857H4A.571.571,0,0,1,4.571,22.286Z",
    style: {
      fill: "#bf85bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-7",
    "data-name": "Rectangle",
    d: "M4.571,13.143h5.714a.571.571,0,0,1,.571.571h0a.571.571,0,0,1-.571.571H4.571A.571.571,0,0,1,4,13.714H4A.571.571,0,0,1,4.571,13.143Z",
    style: {
      fill: "#bf85bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-8",
    "data-name": "Rectangle",
    d: "M10.286,6.286H21.714a.571.571,0,0,1,.571.571h0a.571.571,0,0,1-.571.571H10.286a.571.571,0,0,1-.571-.571h0A.571.571,0,0,1,10.286,6.286Z",
    style: {
      fill: "#f7ba3e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-9",
    "data-name": "Rectangle",
    d: "M4.571,6.286H8a.571.571,0,0,1,.571.571h0A.571.571,0,0,1,8,7.429H4.571A.571.571,0,0,1,4,6.857H4A.571.571,0,0,1,4.571,6.286Z",
    style: {
      fill: "#ea5e5e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-10",
    "data-name": "Rectangle",
    d: "M9.143,24.571h1.143a.571.571,0,0,1,.571.571h0a.571.571,0,0,1-.571.571H9.143a.571.571,0,0,1-.571-.571h0A.571.571,0,0,1,9.143,24.571Z",
    style: {
      fill: "#f7ba3e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-11",
    "data-name": "Rectangle",
    d: "M9.143,10.857h1.143a.571.571,0,0,1,.571.571h0a.571.571,0,0,1-.571.571H9.143a.571.571,0,0,1-.571-.571h0A.571.571,0,0,1,9.143,10.857Z",
    style: {
      fill: "#56b3b4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-12",
    "data-name": "Rectangle",
    d: "M4.571,24.571H6.857a.571.571,0,0,1,.571.571h0a.571.571,0,0,1-.571.571H4.571A.571.571,0,0,1,4,25.143H4A.571.571,0,0,1,4.571,24.571Z",
    style: {
      fill: "#56b3b4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-13",
    "data-name": "Rectangle",
    d: "M4.571,10.857H6.857a.571.571,0,0,1,.571.571h0A.571.571,0,0,1,6.857,12H4.571A.571.571,0,0,1,4,11.429H4A.571.571,0,0,1,4.571,10.857Z",
    style: {
      fill: "#f7ba3e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-14",
    "data-name": "Rectangle",
    d: "M19.429,24.571h1.143a.571.571,0,0,1,.571.571h0a.571.571,0,0,1-.571.571H19.429a.571.571,0,0,1-.571-.571h0A.571.571,0,0,1,19.429,24.571Z",
    style: {
      fill: "#4d616e",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-15",
    "data-name": "Rectangle",
    d: "M12.571,24.571h4.571a.571.571,0,0,1,.571.571h0a.571.571,0,0,1-.571.571H12.571A.571.571,0,0,1,12,25.143h0A.571.571,0,0,1,12.571,24.571Z",
    style: {
      fill: "#4d616e",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-16",
    "data-name": "Rectangle",
    d: "M22.857,24.571h4.571a.571.571,0,0,1,.571.571h0a.571.571,0,0,1-.571.571H22.857a.571.571,0,0,1-.571-.571h0A.571.571,0,0,1,22.857,24.571Z",
    style: {
      fill: "#4d616e",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-17",
    "data-name": "Rectangle",
    d: "M13.714,15.429h9.143a.571.571,0,0,1,.571.571h0a.571.571,0,0,1-.571.571H13.714A.571.571,0,0,1,13.143,16h0A.571.571,0,0,1,13.714,15.429Z",
    style: {
      fill: "#56b3b4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-18",
    "data-name": "Rectangle",
    d: "M8,15.429h3.429A.571.571,0,0,1,12,16h0a.571.571,0,0,1-.571.571H8A.571.571,0,0,1,7.429,16h0A.571.571,0,0,1,8,15.429Z",
    style: {
      fill: "#f7ba3e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-19",
    "data-name": "Rectangle",
    d: "M4.571,15.429H5.714A.571.571,0,0,1,6.286,16h0a.571.571,0,0,1-.571.571H4.571A.571.571,0,0,1,4,16H4A.571.571,0,0,1,4.571,15.429Z",
    style: {
      fill: "#ea5e5e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-20",
    "data-name": "Rectangle",
    d: "M14.857,8.571h4.571A.571.571,0,0,1,20,9.143h0a.571.571,0,0,1-.571.571H14.857a.571.571,0,0,1-.571-.571h0A.571.571,0,0,1,14.857,8.571Z",
    style: {
      fill: "#bf85bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-21",
    "data-name": "Rectangle",
    d: "M4.571,8.571h8a.571.571,0,0,1,.571.571h0a.571.571,0,0,1-.571.571h-8A.571.571,0,0,1,4,9.143H4A.571.571,0,0,1,4.571,8.571Z",
    style: {
      fill: "#56b3b4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-22",
    "data-name": "Rectangle",
    d: "M8,20H18.286a.571.571,0,0,1,.571.571h0a.571.571,0,0,1-.571.571H8a.571.571,0,0,1-.571-.571h0A.571.571,0,0,1,8,20Z",
    style: {
      fill: "#f7ba3e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-23",
    "data-name": "Rectangle",
    d: "M4.571,20H5.714a.571.571,0,0,1,.571.571h0a.571.571,0,0,1-.571.571H4.571A.571.571,0,0,1,4,20.571H4A.571.571,0,0,1,4.571,20Z",
    style: {
      fill: "#bf85bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-24",
    "data-name": "Rectangle",
    d: "M18.286,10.857H24a.571.571,0,0,1,.571.571h0A.571.571,0,0,1,24,12H18.286a.571.571,0,0,1-.571-.571h0A.571.571,0,0,1,18.286,10.857Z",
    style: {
      fill: "#ea5e5e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-25",
    "data-name": "Rectangle",
    d: "M18.286,13.143H24a.571.571,0,0,1,.571.571h0a.571.571,0,0,1-.571.571H18.286a.571.571,0,0,1-.571-.571h0A.571.571,0,0,1,18.286,13.143Z",
    style: {
      fill: "#f7ba3e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-26",
    "data-name": "Rectangle",
    d: "M4.571,4H18.286a.571.571,0,0,1,.571.571h0a.571.571,0,0,1-.571.571H4.571A.571.571,0,0,1,4,4.571H4A.571.571,0,0,1,4.571,4Z",
    style: {
      fill: "#56b3b4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-27",
    "data-name": "Rectangle",
    d: "M20.571,4h6.857A.571.571,0,0,1,28,4.571h0a.571.571,0,0,1-.571.571H20.571A.571.571,0,0,1,20,4.571h0A.571.571,0,0,1,20.571,4Z",
    style: {
      fill: "#4d616e",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-28",
    "data-name": "Rectangle",
    d: "M20.571,20h2.286a.571.571,0,0,1,.571.571h0a.571.571,0,0,1-.571.571H20.571A.571.571,0,0,1,20,20.571h0A.571.571,0,0,1,20.571,20Z",
    style: {
      fill: "#4d616e",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-29",
    "data-name": "Rectangle",
    d: "M25.143,20h2.286a.571.571,0,0,1,.571.571h0a.571.571,0,0,1-.571.571H25.143a.571.571,0,0,1-.571-.571h0A.571.571,0,0,1,25.143,20Z",
    style: {
      fill: "#4d616e",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-30",
    "data-name": "Rectangle",
    d: "M24,17.714h3.429a.571.571,0,0,1,.571.571h0a.571.571,0,0,1-.571.571H24a.571.571,0,0,1-.571-.571h0A.571.571,0,0,1,24,17.714Z",
    style: {
      fill: "#4d616e",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-31",
    "data-name": "Rectangle",
    d: "M24,6.286h3.429A.571.571,0,0,1,28,6.857h0a.571.571,0,0,1-.571.571H24a.571.571,0,0,1-.571-.571h0A.571.571,0,0,1,24,6.286Z",
    style: {
      fill: "#4d616e",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-32",
    "data-name": "Rectangle",
    d: "M25.143,15.429h2.286A.571.571,0,0,1,28,16h0a.571.571,0,0,1-.571.571H25.143A.571.571,0,0,1,24.571,16h0A.571.571,0,0,1,25.143,15.429Z",
    style: {
      fill: "#4d616e",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-33",
    "data-name": "Rectangle",
    d: "M25.143,8.571h2.286A.571.571,0,0,1,28,9.143h0a.571.571,0,0,1-.571.571H25.143a.571.571,0,0,1-.571-.571h0A.571.571,0,0,1,25.143,8.571Z",
    style: {
      fill: "#4d616e",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-34",
    "data-name": "Rectangle",
    d: "M26.286,10.857h1.143a.571.571,0,0,1,.571.571h0a.571.571,0,0,1-.571.571H26.286a.571.571,0,0,1-.571-.571h0A.571.571,0,0,1,26.286,10.857Z",
    style: {
      fill: "#4d616e",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-35",
    "data-name": "Rectangle",
    d: "M26.286,13.143h1.143a.571.571,0,0,1,.571.571h0a.571.571,0,0,1-.571.571H26.286a.571.571,0,0,1-.571-.571h0A.571.571,0,0,1,26.286,13.143Z",
    style: {
      fill: "#4d616e",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-36",
    "data-name": "Rectangle",
    d: "M17.143,22.286H27.429a.571.571,0,0,1,.571.571h0a.571.571,0,0,1-.571.571H17.143a.571.571,0,0,1-.571-.571h0A.571.571,0,0,1,17.143,22.286Z",
    style: {
      fill: "#4d616e",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-37",
    "data-name": "Rectangle",
    d: "M12.571,22.286h2.286a.571.571,0,0,1,.571.571h0a.571.571,0,0,1-.571.571H12.571A.571.571,0,0,1,12,22.857h0A.571.571,0,0,1,12.571,22.286Z",
    style: {
      fill: "#4d616e",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-38",
    "data-name": "Rectangle",
    d: "M21.714,26.857h5.714a.571.571,0,0,1,.571.571h0a.571.571,0,0,1-.571.571H21.714a.571.571,0,0,1-.571-.571h0A.571.571,0,0,1,21.714,26.857Z",
    style: {
      fill: "#4d616e",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-39",
    "data-name": "Rectangle",
    d: "M12.571,26.857h6.857a.571.571,0,0,1,.571.571h0a.571.571,0,0,1-.571.571H12.571A.571.571,0,0,1,12,27.429h0A.571.571,0,0,1,12.571,26.857Z",
    style: {
      fill: "#4d616e",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-40",
    "data-name": "Rectangle",
    d: "M12.571,10.857H16a.571.571,0,0,1,.571.571h0A.571.571,0,0,1,16,12H12.571A.571.571,0,0,1,12,11.429h0A.571.571,0,0,1,12.571,10.857Z",
    style: {
      fill: "#4d616e",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-41",
    "data-name": "Rectangle",
    d: "M12.571,13.143H16a.571.571,0,0,1,.571.571h0a.571.571,0,0,1-.571.571H12.571A.571.571,0,0,1,12,13.714h0A.571.571,0,0,1,12.571,13.143Z",
    style: {
      fill: "#4d616e",
      opacity: 0.5,
      isolation: "isolate"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrettierIcon);
export default __webpack_public_path__ + "static/media/prettierIcon.e2b5ad93628d06b62d455412ac6a7f70.svg";
export { ForwardRef as ReactComponent };